/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import type ProjectSettingsServiceDeskFeedbackSettingsType from '@jira/spa-apps__project-settings-service-desk-feedback-settings/src/ServiceDeskFeedbackSettingsPage.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

export const NEXTGEN_SETTINGS = 'project/service-desk/settings/index';
export const CLASSIC_SETTINGS = 'project/service-desk/settings';

export const LazyProjectSettingsServiceDeskFeedbackSettings: LazyComponent<
	typeof ProjectSettingsServiceDeskFeedbackSettingsType
> = lazyForPaint<typeof ProjectSettingsServiceDeskFeedbackSettingsType>(
	() =>
		import(
			/* webpackChunkName: "async-project-settings-service-desk-feedback-settings", jiraSpaEntry: "async-project-settings-service-desk-feedback-settings" */ '@jira/spa-apps__project-settings-service-desk-feedback-settings/src/ServiceDeskFeedbackSettingsPage.tsx'
		),
);

const AsyncProjectSettingsServiceDeskFeedbackSettings = (): React.JSX.Element => (
	<LazyPage
		Page={LazyProjectSettingsServiceDeskFeedbackSettings}
		pageId="project-settings-feedback-settings"
		shouldShowSpinner
	/>
);

export default AsyncProjectSettingsServiceDeskFeedbackSettings;
